import { render } from "./StatusDropdown.vue?vue&type=template&id=bc5c2b30"
import script from "./StatusDropdown.vue?vue&type=script&lang=js"
export * from "./StatusDropdown.vue?vue&type=script&lang=js"

import "./StatusDropdown.vue?vue&type=style&index=0&id=bc5c2b30&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__